(() => {
  console.log('HELLO SLAVA');
})()
